module.exports = __webpack_public_path__ + "media/images/sakai_logo_square_36-22c14f449c8b4c7603b4c1d36124660e.png";